<div class="row my-bu">
    <div class="m-b-25 head-component">
        <div class="col-10 ml-0 pl-0 for-fixed-component br-0 head-component card">
            <div class="col-9 card-body">
                <div class="float-left">
                    <h5 class="m-0 head-main-component">
                            {{ 'lang.userMenu.myBU'  | translate}}
                    </h5>
                    <div class="filter">
                        <span (click)="emitSurveyTabValue(false)" [routerLink]="['confirmations']" routerLinkActive="filter-active">{{ 'lang.userMenu.navigation.approveRespondents'  | translate }}</span>
                        <span [routerLink]="['bu-reports']" routerLinkActive="filter-active">{{ 'lang.userMenu.navigation.reports'  | translate }}</span>
                        
                        <!-- TODO: - Survey Report navigation -->
                        <!-- <span (click)="emitSurveyTabValue(true)" [ngClass] = "{'filter-active': isSurveyTabActive}">{{ 'lang.userMenu.navigation.surveys'  | translate }}</span> -->
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="col-9 p-l-25">
        <router-outlet></router-outlet>
    </div>
    <div class="col-3 pl-0">
        <div class="bg-none pl-0">
            <div class="card-body p-0">
                <div class="row info-panel">
                    <div class="col-1">
                        <i class="mdi mdi-information-outline"></i>
                    </div>
                    <div class="col-10">
                        {{ 'lang.user.userHelp'  | translate}}
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
